import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

import { ChargebeeRoutingModule } from './chargebee-routing.module';
import { SubscriptionComponent } from './subscription/subscription.component';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PortalComponent } from './portal/portal.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTransitionPatchModule } from 'ng-zorro-antd/core/transition-patch/transition-patch.module';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import {NzGridModule} from "ng-zorro-antd/grid";
import {NzSliderModule} from "ng-zorro-antd/slider";
import {NzInputNumberModule} from "ng-zorro-antd/input-number";
import {NzDividerModule} from "ng-zorro-antd/divider";
import {LucideAngularModule} from "lucide-angular";
import {NzAlertModule} from "ng-zorro-antd/alert";

@NgModule({
  declarations: [SubscriptionComponent, PortalComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    ChargebeeRoutingModule,
    RouterOutlet,
    FormsModule,
    NzButtonModule,
    NzSpinModule,
    NzGridModule,
    NzSliderModule,
    NzInputNumberModule,
    NzDividerModule,
    LucideAngularModule,
    NzAlertModule,
  ],
})
export class ChargebeeModule {}
